import { useAppSelector } from 'store/hooks';
import { selectIsBreakoutRoom } from 'features/breakout-rooms/breakoutRoomsSlice';
import { selectRoomName } from 'features/room/roomSlice';
import { Box, Typography } from '@mui/material';

const RoomName = () => {
  const isBreakoutRoom = useAppSelector(selectIsBreakoutRoom);

  const roomName = useAppSelector(selectRoomName);

  const displayRoomName = isBreakoutRoom && roomName;

  if (!displayRoomName) {
    return null;
  }

  return (
    <Box
      sx={(theme) => ({
        display: 'none',
        flex: 1,
        textAlign: 'center',
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        [theme.breakpoints.up('lg')]: {
          display: 'block',
        },
      })}
    >
      <Typography>{roomName}</Typography>
    </Box>
  );
};

export default RoomName;
